import { PropsWithChildren } from "react";

export enum MDSPanelHeaderRounded {
  None = "none",
  TopLeft = "topLeft",
  TopRight = "topRight",
}

export interface MDSPanelHeaderProps extends PropsWithChildren {
  rounded?: MDSPanelHeaderRounded;
  backgroundColor?: string;
  bottomBorderColor?: string;
  isSidePanel?: boolean;
}

export enum MDSPanelHeaderSlotName {
  Heading = "heading",
  Subsection = "subsection",
  Actions = "actions",
}
